import { Icon, InputText } from '@fattureincloud/fic-design-system'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import {
  faExclamationTriangle,
  faMagic,
  faPencil,
} from '@fortawesome/pro-light-svg-icons'
import parse, { HTMLReactParserOptions } from 'html-react-parser'
import React, { FC, forwardRef, useCallback, useMemo } from 'react'
import ContentLoader from 'react-content-loader'
import styled, { css } from 'styled-components'

import FICColors from '../../common/FICColors'

export const sidebarOffsetTop = !localStorage.getItem(
  'helpFacebookBannerIsVisible'
)
  ? 50
  : 40

export const FroalaWrapper = styled.div`
  .fr-box.fr-basic .fr-element
  {
    font-weight: 400;
    color:#555555 !important;
    font-family: 'Open Sans', sans-serif !important;
  }
  .fr-quick-insert { display: none !important; }
  .fr-insert-helper { display: none !important; }
  .fr-box.fr-basic .fr-element.fr-view {
    text-align: justify;
    font-size: 16px;
    padding: 20px;
    width: 656px;
    td {
      a:hover,
      a:focus {
        cursor: pointer;
        text-decoration: underline !important;
      }
    }
  }
`

export const ArticleOptions = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
  display: flex;
  column-gap: 8px;
  justify-content: space-between;
  font-family: 'Open Sans', sans-serif !important;
`

export const ArticleTitleInsert = styled(InputText)`
  margin-bottom: 24px;
`
interface ArticleContainerProps {
  subArticle: boolean
  adminMode: boolean
  editorModeActive: boolean
}

export const ArticleContainer = styled.div<ArticleContainerProps>`
  margin: ${(props) => (props.subArticle ? undefined : '40px auto')};
  width: 100%;
  max-width: 1200px;
  ${(props) =>
    props.adminMode && props.editorModeActive &&
    css`
    max-width: unset;
    display: block;
    min-width: 915px;
  `}
  text-align: center;
  color:#555555;
  table {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    word-break: break-word !important;
    white-space: -o-pre-wrap !important;
    white-space: pre-wrap !important;
    white-space: -moz-pre-wrap !important;
  }
  @media (max-width: 425px) {
    margin-top: 0;
    table {
      ul {
        margin: 0 15px 15px 0;
        list-style-position: inside;
        overflow: scroll;
        li {
          text-align: left !important;
          margin-bottom: 10px;
        }
      }
    }
  }
  
  @media (max-width: 1200px)
  {
      margin-top:0;
  }
  
  .cursor-pointer
  {
      cursor: pointer;
  }
`

interface ArticleContentProps {
  hasSidebar: boolean
  embedded: boolean
  fixedSideBar: boolean
  editorActive: boolean
}

export const FroalaStatisticsContainer = styled.div`
  display: inline-block;
  max-width: 1200px;
  top: 23px;
  min-width: 915px;
`

export const ArticleContent = styled.div<ArticleContentProps>`
  display: ${(props) => (props.editorActive ? 'table-cell' : 'inline-block')};
  //color:#555555;
  font-weight: 400;
  width: ${(props) => (props.editorActive?'656px':'616px')};
  max-width: ${(props) => (props.embedded ? '448px' : props.editorActive?'656px':'616px')};
  padding-left: 16px;
  padding-right: 16px;
  color: ${FICColors.textDefault};
  font-size: 16px !important;
  line-height: 24px;
  vertical-align: top;
  text-align: left;
  ${(props) =>
    props.hasSidebar &&
    css`
      margin-left: 320px;
    `}
    
  @media screen and (max-width: 1200px)
  {
    margin-left:0;
  }  
    
  li {
    line-height: 24px;
  }
  p {
    margin: 0 0 10px;
  }
  img {
    max-width: 100%;
    vertical-align: middle;
    border: 1px solid rgba(51, 51, 51, 0.24);
    box-sizing: border-box;
    height: auto !important;
    border-radius: 4px;
  }
  table {
    border-collapse: collapse;
    ${(props) =>
    props.editorActive === false &&
    css`
        font-family: 'Open Sans', sans-serif !important;
        font-size: 16px !important;
        width: 100% !important;
        td {
          border: none !important;
          a:hover,
          a:focus {
            cursor: pointer;
            text-decoration: underline !important;
          }
      `}
  }
  hr {
    margin: 20px 0;
    border: 0;
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #ffffff;
  }
  h2,
  h3 {
    line-height: 40px;
  }
  h3 {
    margin-bottom: 16px;
  }
  a:hover,
  a:focus {
    cursor: pointer;
    text-decoration: underline !important;
  }
`

interface ArticleLoadingSvgProps {
  isExternal: boolean
  className: string
}
export const ArticleLoadingSvg: FC<ArticleLoadingSvgProps> = (
  props: ArticleLoadingSvgProps
) => (
  <div className={props.className + ' articleLoading'}>
    <ContentLoader
      height={160}
      width={300}
      speed={2}
      foregroundColor='#f3f3f3'
      backgroundColor='#ecebeb'
      className={props.className}
    >
      <rect x='5' y='2' rx='3' ry='3' width='70' height='10' />
      <rect x='85' y='2' rx='3' ry='3' width='100' height='10' />
      <rect x='195' y='2' rx='3' ry='3' width='10' height='10' />
      <rect x='20' y='22' rx='3' ry='3' width='130' height='10' />
      <rect x='160' y='22' rx='3' ry='3' width='130' height='10' />
      <rect x='20' y='42' rx='3' ry='3' width='90' height='10' />
      <rect x='120' y='42' rx='3' ry='3' width='60' height='10' />
      <rect x='190' y='42' rx='3' ry='3' width='60' height='10' />
      <rect x='5' y='102' rx='3' ry='3' width='30' height='10' />
      <rect x='19' y='81' rx='3' ry='3' width='90' height='10' />
      <rect x='119' y='81' rx='3' ry='3' width='60' height='10' />
      <rect x='189' y='81' rx='3' ry='3' width='60' height='10' />
      <rect x='20' y='62' rx='3' ry='3' width='130' height='10' />
      <rect x='173' y='60' rx='3' ry='3' width='130' height='10' />
    </ContentLoader>
  </div>
)

export const ArticleLoading = styled(ArticleLoadingSvg) <{
  isExternal: boolean
  className: string
}>`
  height: 160px;
  width: 100%;
  margin: 0 auto;
  max-width: 940px;
  svg {
    width: 300px;
  }
  ${(props) =>
    !props.isExternal &&
    css`
      margin: 15px auto;
    `}
`

export const helpHeaderHeight = !localStorage.getItem(
  'helpFacebookBannerIsVisible'
)
  ? 130
  : 90

export const Actions = styled.div`
  @media print {
    display: none;
  }
  text-align: right;
  margin-bottom: 10px;
  a {
    margin-left: 10px;
    position: relative;
    top: -5px;
  }
  a,
  a:hover,
  a:focus {
    text-decoration: none;
  }
  .svg-inline--fa {
    display: inline-block;
    color: #555 !important;
    font-size: 22px;
    cursor: pointer;
    &:hover {
      color: ${FICColors.defaultBlue}!important;
    }
  }
  a > .svg-inline--fa {
    margin-top: 5px;
  }
`

function customBlockIcon(type) {
  let icon: IconDefinition = faExclamationTriangle
  switch (type) {
    case 'hint':
      icon = faMagic
      break
    case 'note':
      icon = faPencil
      break
    case 'warning':
      icon = faExclamationTriangle
      break
  }
  if (icon) {
    return (
      <span className='iconContainer'>
        <Icon icon={icon} />
      </span>
    )
  }
}

interface Props_2 extends React.ComponentPropsWithRef<'div'> {
  //TODO spostare in un file a parte
  type: string
  id: string
  text: string
}
export const CustomBlockImpl = forwardRef<HTMLDivElement, Props_2>(
  (forwardedProps, ref) => {
    const props = { ...forwardedProps }
    const options: HTMLReactParserOptions = {
      replace: (domNode) => {
        return domNode
      },
    }

    const renderContent = useCallback(() => {
      if (props.text === '') return <></>
      return parse(props.text, options)
    }, [])

    const renderArticleContent = useMemo(() => renderContent(), [])

    return (
      <div
        ref={ref}
        className={props.className + ' ' + props.type}
        id={props.id ? props.id : undefined}
      >
        {customBlockIcon(props.type)}
        <div className='text'>{renderArticleContent}</div>
      </div>
    )
  }
)
CustomBlockImpl.displayName = 'CustomBlockImpl'

export const CustomBlock = styled(CustomBlockImpl)`
  padding: 12px;
  border: 1px solid rgba(51, 51, 51, 0.24);
  border-radius: 4px;
  margin: 24px auto;
  .text {
    display: table-cell;
    vertical-align: middle;
    width: calc(100% - 35px);
  }
  .fa,
  .faicon {
    padding-right: 12px;
    font-size: 26px;
    display: table-cell;
    vertical-align: middle;
  }

  .hint {
    border-color: #0078cd;
    background-color: rgba(0, 120, 205, 0.08);
  }

  .hint .fa,
  .hint .faicon {
    color: #0078cd;
  }

  .note {
    border-color: #23c499;
    background-color: rgba(35, 196, 153, 0.08);
  }
  .note .fa,
  .note .faicon {
    color: #23c499;
  }

  .warning {
    border-color: #ffbe2d;
    background-color: rgba(255, 190, 45, 0.08);
  }
  .warning .fa,
  .warning .faicon {
    color: #ffbe2d;
  }

  .section {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid rgba(51, 51, 51, 0.24);
    font-size: 22px;
    font-weight: bold;
    line-height: 30px;
    padding: 24px 0 5px 0;
    margin-top: 0 !important;
    box-shadow: none;
  }
  .section:first-child {
    padding-top: 0;
  }
  .section:not(:first-child) {
    margin-top: 32px;
  }
  .section .fa,
  .section .faicon {
    display: none;
  }

  .svg-inline--fa {
    font-size: 23px;
  }
  span.iconContainer {
    display: table-cell;
    vertical-align: middle;
  }
  &.hint {
    border-color: #0078cd;
    background-color: rgba(0, 120, 205, 0.08);
    .svg-inline--fa {
      color: #0078cd;
    }
  }
  &.note {
    border-color: #23c499;
    background-color: rgba(35, 196, 153, 0.08);
    .svg-inline--fa {
      color: #23c499;
    }
  }
  &.warning {
    border-color: #ffbe2d;
    background-color: rgba(255, 190, 45, 0.08);
    .svg-inline--fa {
      color: #ffbe2d;
    }
  }
  .text {
    display: table-cell;
    vertical-align: top;
    width: calc(100% - 35px);
  }
  &.section {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid rgba(51, 51, 51, 0.24);
    font-size: 22px;
    font-weight: bold;
    line-height: 30px;
    padding: 24px 0 5px 0;
    margin-top: 0 !important;
    box-shadow: none;
    &:first-child {
      padding-top: 0;
    }
    &:not(:first-child) {
      margin-top: 32px;
    }
    .svg-inline--fa {
      display: none;
    }
  }
`

export const AdminDataContainer = styled.div`
  margin-bottom: 36px;
`
export const ToolbarContainer = styled.div`
  margin-top: 15px;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 3;
  background-color: white;
`

export const ArticleActionsBox = styled.div`
  position: sticky;
  top: 23px;
  z-index: 3;
  background-color: white;
  float: right;
  max-width: 200px;
  margin-left: 24px;
  @media screen and (max-width: 1200px)
  {
    position: initial;
  }
`

export const RelatedArticleTitle = styled.h3`
  line-height: 40px;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 400;
`
